class DeviceStatisticModel extends App.Models.BaseModel {
    modelUrl = 'DeviceStatistic';
}

App.Models.DeviceStatistic = DeviceStatisticModel;